<template>
    <div style="padding: 20px;">


        <div v-auth="'资源编码'">是否展示</div>

        数据字典：
        <div v-html="msg1"></div>


        <br>
        <hr>
        常用校验：

        { required: true, message: '必输输入', trigger: 'blur'}, <br>
        { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' } <br>
        { type: 'number', message: '必须为数字值'} <br>
        常用type:  string  integer number integer float email


        <br>
        下载：<br>
        import down from '../../utils/downutil'<br>
        down("下载的url地址",{参数对象});

    </div>
</template>
<script>
    export default {
        data(){
           return {
            msg1:`
                <brselect category="shifou_keyong" :v="q.delflag" v-model="q.delflag"/>
            `,
            msg2:``,
            msg3:``,
            msg4:``,
           }
        }
    }



</script>
